import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectSelectedContext } from '~/store/profile/profileSlice.selectors';

type CurrentContext = {
  organizationsId?: string;
  hubsId?: string;
  fleetsId?: string;
};

/**
 * @returns current session-level org context preference, either set by the user or defaulted based on user profile assignment
 */
const useCurrentContext = (): CurrentContext | undefined => {
  const selectedContext = useSelector(selectSelectedContext);

  const currentContext: CurrentContext | undefined = useMemo(() => {
    const { id, parentIds } = selectedContext || {};

    if (!id) return undefined;

    const newContext: typeof currentContext = {
      organizationsId: parentIds?.[0] ?? id,
      hubsId: parentIds?.length === 1 ? id : parentIds?.[1],
      fleetsId: parentIds?.length === 2 ? id : undefined,
    };

    return newContext;
  }, [selectedContext]);

  return currentContext;
};

export default useCurrentContext;
